"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const lodash_1 = tslib_1.__importDefault(require("lodash"));
function arrayMerger(a, b, key) {
    if (a && Array.isArray(a) && b && Array.isArray(b)) {
        const merged = lodash_1.default.merge(lodash_1.default.keyBy(a, key), lodash_1.default.keyBy(b, key));
        const values = lodash_1.default.values(merged);
        return values;
    }
    else {
        throw new Error('Error in input arguments');
    }
}
exports.arrayMerger = arrayMerger;
//# sourceMappingURL=arrayMerger.js.map